// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"447":"fxaPairingChannel","791":"fast-text-encoding","843":"common-password-list","982":"fxaCryptoDeriver"}[chunkId] || chunkId) + ".bundle.js";
};